// `/app/checkout-sessions` (WEB-150): aba "Cartão internacional" de Transações. O filtro de
// status vive na query string (`spec/17` §3); a tela é `features/checkout-sessions`.

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { CheckoutSessionsScreen } from '../features/checkout-sessions/checkout-sessions-screen.tsx';
import { SESSION_STATUS_FILTERS } from '../features/checkout-sessions/model.ts';

const searchSchema = z.object({
  status: z.enum(SESSION_STATUS_FILTERS).optional().catch(undefined),
});

function CheckoutSessions() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  return (
    <CheckoutSessionsScreen
      status={search.status}
      onStatusChange={(status) => {
        void navigate({
          to: '/app/checkout-sessions',
          search: status === undefined ? {} : { status },
          replace: true,
        });
      }}
      onOpenTransaction={(id) => {
        void navigate({ to: '/app/transactions/$id', params: { id } });
      }}
    />
  );
}

export const Route = createFileRoute('/app/checkout-sessions')({
  validateSearch: searchSchema,
  component: CheckoutSessions,
});
